export default __webpack_public_path__ + "static/media/PAUTO.d4b59ff4.png";